const URL = {
  VIDEO_DIRECTORY_GET_ROOT: 'Media/videos/filter',
  MEDIA_DIRECTORY_GET_ROOT: 'Media/images/filter',
  MEDIA_DIRECTORY_GET: 'Media/GetDirectory',
}

export default URL
